import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { IUserInfo } from '../../../types/user'

import useGetSingleUser from '../../../hooks/user/useGetSingleUser';

import ViewsLayout from '../../layouts/ViewsLayout';
import Questionnaire from '../../sub_components/applicant_details/Questionnaire';
import Information from '../../sub_components/applicant_details/Information';
import Programs from '../../sub_components/applicant_details/Programs';
// import Notes from '../../sub_components/applicant_details/Notes';
import StatusManager from '../../sub_components/applicant_details/StatusManager';
import Organization from '../../sub_components/applicant_details/Organization';
import { ImmigrationApplications } from '../../sub_components/applicant_details/ImmigrationApplications';

const Details = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [applicant, setApplicant] = useState('main');
    const [activeTab, setActiveTab] = useState('questionnaire');
    const [user, setUser] = useState<IUserInfo | null>(null);

    const { data: userData, isPending, isError } = useGetSingleUser(Number(id));

    useEffect(() => {
        setUser(userData ? userData : null);
    }, [userData]); //eslint-disable-line

    const handleApplicantChange = (name: string) => {
        setApplicant(name);
    };

    const handleTabChange = (tabId: string) => {
        setActiveTab(tabId);
    };

    if (isPending) return <div>Loading...</div>
    if (isError) return <div>Error</div>

    return (
        <ViewsLayout>
            <div className='imm_home__main_view'>
                <div className='imm_details__main_content'>

                    <div className="imm_home__details_card">
                        <div className="imm_home__details_card_title"><h2>Applicant</h2></div>
                        <div className="imm_home__details_info">
                            <div>
                                <p><strong>First Name:</strong> {user?.applicant?.first_name}</p>
                                <p><strong>Last Name:</strong> {user?.applicant?.last_name}</p>
                                <p><strong>SIN Expiry:</strong>&nbsp;{user?.applicant?.sin_expiry ? new Date(user?.applicant?.sin_expiry).toLocaleDateString() : 'N/A'}</p>
                            </div>
                            <div>
                                <p><strong>Email:</strong> {user?.applicantUser?.email}</p>
                                <p><strong>Phone:</strong> {user?.applicant?.phone_number}</p>
                            </div>
                        </div>
                        <div className="imm_home__details_button">
                            <button
                                className={applicant === "main" ? "inactive" : ""}
                                onClick={() => handleApplicantChange('main')}
                            >
                                {applicant === "main" ? "Current User" : "View User"}
                            </button>
                        </div>
                    </div>

                    {user?.spouse ? <div className="imm_home__details_card">
                        <div className="imm_home__details_card_title"><h2>Spouse</h2></div>
                        <div className="imm_home__details_info">
                            <div>
                                <p><strong>First Name:</strong> {user?.spouse?.first_name}</p>
                                <p><strong>Last Name:</strong> {user?.spouse?.last_name}</p>
                            </div>
                            <div>
                                <p><strong>Email:</strong> {user?.applicantUser?.email}</p>
                                <p><strong>Phone:</strong> {user?.spouse?.phone_number}</p>
                            </div>
                        </div>
                        <div className="imm_home__details_button">
                            <button
                                className={applicant === "spouse" ? "inactive" : ""}
                                onClick={() => handleApplicantChange('spouse')}
                            >
                                {applicant === "spouse" ? "Current User" : "View User"}
                            </button>
                        </div>
                    </div> : <div className="imm_home__details_card">
                        <div className="imm_home__details_card_title"><h2>No Spouse</h2></div>
                    </div>}

                    <div className="imm_home__back_button"><button onClick={() => navigate(`/`)}>{"Back"}</button></div>

                    <div className="imm_home__details_button_tabs_container">

                        <div className="imm_home__details_button_tabs_buttons">
                            <button onClick={() => handleTabChange('questionnaire')} className={activeTab === 'questionnaire' ? 'active' : ''}>Questionnaire</button>
                            <button onClick={() => handleTabChange('information')} className={activeTab === 'information' ? 'active' : ''}>Information</button>
                            <button onClick={() => handleTabChange('programs')} className={activeTab === 'programs' ? 'active' : ''}>Programs</button>
                            <button onClick={() => handleTabChange('status-manager')} className={activeTab === 'status-manager' ? 'active' : ''}>Status Manager</button>
                            <button onClick={() => handleTabChange('organizations')} className={activeTab === 'organizations' ? 'active' : ''}>Organizations</button>
                            <button onClick={() => handleTabChange('immigration-applications')} className={activeTab === 'immigration-applications' ? 'active' : ''}>Immigration Applications</button>
                            {/* <button onClick={() => handleTabChange('notes')} className={activeTab === 'notes' ? 'active' : ''}>Notes</button> */}
                        </div>

                        {activeTab === 'questionnaire' && (
                            <Fragment>
                                {user?.applicant?.immigrant_id &&
                                    <Questionnaire applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                                }
                            </Fragment>
                        )}
                        {activeTab === 'information' && (
                            <Information applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                        )}
                        {activeTab === 'programs' && (
                            <Programs
                                applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)}
                                userId={Number(user?.applicantUser?.id)} applicant={applicant} user={user || null}
                            />
                        )}

                        {activeTab === 'status-manager' && (
                            <StatusManager applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                        )}

                        {activeTab === 'organizations' && (
                            <Organization applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                        )}

                        {activeTab === 'immigration-applications' && (
                            <ImmigrationApplications applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                        )}

                        {/* {activeTab === 'notes' && (
                            <Notes applicantId={applicant === "main" ? Number(user?.applicant?.id) : Number(user?.spouse?.id)} />
                        )} */}
                    </div>

                </div>
            </div>
        </ViewsLayout>
    );
}

export default Details;